<template>
  <div>
    <div class="tw-flex tw-flex-col tw-gap-2">
      <h1 class="tw-font-bold tw-text-xl lg:tw-text-2xl xl:tw-text-3xl">
        Sign in
      </h1>
      <div class="tw-flex tw-flex-col tw-mt-0 lg:tw-mt-4 tw-gap-2">
        <p class="tw-font-semibold pa-0 ma-0 tw-opacity-75 xl:tw-text-xl">
          Welcome to Rentings
        </p>
        <p class="tw-text-xs pa-0 ma-0 tw-opacity-50 lg:tw-text-base">
          Please sign in to your account and start the adventure
        </p>
      </div>
    </div>
    <div class="lg:tw-mt-10 tw-mt-6">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="">
            <ValidationProvider
              v-slot="{ errors }"
              name="User Name"
              :rules="{ required: true }"
            >
              <v-text-field
                v-model="userDetails.phone"
                :error-messages="errors"
                :label="$t('user.username')"
                outlined
                dense
              ></v-text-field>
            </ValidationProvider>
          </div>
          <div class="">
            <ValidationProvider
              v-slot="{ errors }"
              :rules="{ required: true }"
              name="Password"
            >
              <v-text-field
                v-model="userDetails.password"
                :error-messages="errors"
                :label="$t('user.password')"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                @click:append="show = !show"
                outlined
                dense
              ></v-text-field>
            </ValidationProvider>
          </div>

          <div class=" tw-flex tw-justify-end">
            <button
              type="submit"
              :loading="btn_loading"
              class="lg:tw-text-sm tw-text-light tw-font-medium tw-rounded-md tw-text-xs tw-bg-primary tw-py-2 tw-px-8"
            >
              {{ $t("common.signin") }}
            </button>
          </div>
          <!-- <v-btn
              depressed
              color="primary"
              class="ml-3 white--text font-weight-light"
              :min-width="$vuetify.breakpoint.xs ? 150 : 385"
              type="submit"
              :loading="btn_loading"
              >{{ $t("common.signin") }}</v-btn
            > -->
        </form>
      </ValidationObserver>
      <p v-if="errorFromApi" class="mt-6 text-center red--text">
        {{ errorFromApi }}
      </p>
    </div>
  </div>
</template>

<script>
import { adminSignIn } from "../methods/signin.js";
import "@/core/methods/validation_rules";
// import { isDietitian } from "../../user/methods/helper.js";

import { setInteractionMode } from "vee-validate";

setInteractionMode("eager");

export default {
  data() {
    return {
      show: false,
      userDetails: {},
      btn_loading: false,
      errorFromApi: null,
      style: {
        borderStyle: { border: "0px solid black !important" }
      }
    };
  },
  methods: {
    onSubmit() {
      this.$refs.observer.validate();
      // this.$store.state.signin = true;

      this.btn_loading = true;
      adminSignIn(this.userDetails.phone, this.userDetails.password).then(
        data => {
          if (data) {
            if (data === true) {
              this.btn_loading = false;
              this.$router.replace({ path: "dashboard" });
              this.$root.$emit("snackbar", {
                snackbar: true,
                text: this.$t("common.loginSuccess"),
                color: "green"
              });
              // if (isDietitian()) {
              //   this.$router.replace({ path: "appointments" });
              // } else {
              //   this.$router.replace({ path: "dashboard" });
              // }
            } else if (data.includes("NOT_FOUND")) {
              this.errorFromApi = this.$t("user.signIn.invalidLogin");
              this.btn_loading = false;
            } else {
              this.errorFromApi = this.$t("user.signIn.invalidLogin");
              this.btn_loading = false;
            }
          }
        }
      );
    }
  }
};
</script>

<style>
.inputPhone input[type="number"] {
  appearance: textfield;
  -moz-appearance: textfield;
}
.inputPhone input::-webkit-outer-spin-button,
.inputPhone input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
